import { inject, Service } from '@angular/core';
import { IQuestionPayload } from 'app/core/interfaces/general.interface';
import { Observable, throwError } from 'rxjs';
import { first, mergeMap } from 'rxjs/operators';
import { ApiClient } from '../../api/api-client';
import { Api } from '../../api/generated/api';
import { FingerprintService } from '../../core/providers/fingerprint/fingerprint.service';
import { OneMoreQuestion, IOneMoreQuestionOption } from './interfaces/one-more-question.interface';

@Service()
export class OneMoreQuestionService {
  private fingerprintService = inject(FingerprintService);
  private api = inject(ApiClient);

  private oneMoreQuestionResponse: OneMoreQuestion | null = null;

  setOneMoreQuestionResponse(response: OneMoreQuestion): void {
    this.oneMoreQuestionResponse = response;
  }

  getOneMoreQuestionResponse(): OneMoreQuestion | null {
    return this.oneMoreQuestionResponse;
  }

  sendQuestion(payload: IQuestionPayload): Observable<unknown> {
    const { token } = payload;
    if (!token) {
      return throwError(() => new Error('Cannot send the answer without a survey token'));
    }

    return this.fingerprintService.visitorId$().pipe(
      first(),
      mergeMap((visitorId: string) =>
        this.api.post(Api.surveys.takeaway.oneMoreQuestion.response, {
          body: { ...payload, token, visitorId },
        })
      )
    );
  }

  isFollowQuestionActive(selectedOptions: boolean[], options: IOneMoreQuestionOption[]): boolean {
    const questionOptions: boolean[] = this.getTriggerValues(options);

    if (selectedOptions.length !== questionOptions.length) {
      return false;
    }
    for (let i = 0; i < questionOptions.length; i++) {
      if (questionOptions[i] && selectedOptions[i]) {
        return true;
      }
    }

    return false;
  }

  isTriggeredAlways(options: IOneMoreQuestionOption[]): boolean {
    return this.getTriggerValues(options).every((v: boolean) => v === true);
  }

  getTriggerValues(options: IOneMoreQuestionOption[]): boolean[] {
    return options.map((option: IOneMoreQuestionOption) => option.isTrigger === true);
  }

  getTriggerStaticValues(options: IOneMoreQuestionOption[]): number {
    return options.findIndex((option: IOneMoreQuestionOption) => option.isTrigger === true);
  }
}
